"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ProjectableReaderObjectConverter_1 = require("../../core/conversions/ProjectableReaderObjectConverter");
/**
 * @author Adam Drda
 */


var BaselineConverter =
/*#__PURE__*/
function (_ProjectableReaderObj) {
  _inherits(BaselineConverter, _ProjectableReaderObj);

  function BaselineConverter() {
    _classCallCheck(this, BaselineConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(BaselineConverter).apply(this, arguments));
  }

  return BaselineConverter;
}(ProjectableReaderObjectConverter_1.ProjectableReaderObjectConverter);

exports.BaselineConverter = BaselineConverter;